<script setup lang="ts">
import { useAsyncData } from "#app";
import { repository } from "~/repository";

const route = useRoute();
const pageSlug = route.params.slug as string;

const { data, pending } = await useAsyncData(
  () => repository.common.fetchDocument({ slug: pageSlug }),
  { lazy: true },
);

useSeoMeta({
  title: () => data.value?.data.title || "",
  description: () => data.value?.data.title,

  ogTitle: () => data.value?.data.title,
  ogDescription: () => data.value?.data.title,

  twitterTitle: () => data.value?.data.title,
  twitterDescription: () => data.value?.data.title,
});
</script>

<template>
  <div>
    <div class="h-20"></div>
    <div v-if="pending && !data" class="mt-20 text-center">
      <ProgressSpinner class="!h-20 !w-20" />
    </div>
    <div v-else class="mx-auto max-w-screen-lg px-5 py-12 lg:px-0">
      <ArticleContent :content="data?.data.content" />
    </div>
  </div>
</template>

<style lang="scss">
.html-container {
  h1 {
    font-family: "UniSans";
    font-size: 2.8em;
    font-weight: bold;
  }
  h2 {
    font-family: "SemiBold";
    font-size: 2em;
    line-height: 32px;
    font-weight: 600;
  }
  h3 {
    font-family: "UniSans";
    font-size: 1.5em;
    font-weight: bold;
    font-style: italic;
  }

  h4 {
    font-family: "UniSans";
    font-size: 1.25em;
    font-weight: 600;
  }

  h5 {
    font-size: 16px;
  }

  h6 {
    font-size: 12px;
  }

  body {
    font-family: UniSans, sans-serif;
    font-size: 16px;
    letter-spacing: 0.5px;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    line-height: 1.35;
  }

  p {
    margin-bottom: 20px !important;
    line-height: 1.35;
  }
}
</style>
